<div class="form-horizontal">
  <div class="form-group">

    <div class="col-md-6 col-lg-4">
      <label class="control-label col-md-5 col-lg-4">Laboratory</label>
      <div class="col-md-7 col-lg-8">
        <div class="input-group">
          <select class="form-control" [(ngModel)]="selectedLaboratoryId" [ngModelOptions]="{ standalone: true }">
            <option [ngValue]="null"></option>
            <option *ngFor="let option of laboratories" [ngValue]="option.id">{{ option.display }}</option>
          </select>
          <span class="input-group-btn">
            <button type="button" class="btn btn-success" (click)="addAnalysis()">Add</button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-vertical-tab-group>
  <app-vertical-tab
      *ngFor="let selectedLab of samplingNeeds.controls; let i = index"
      [title]="nameOfLab(selectedLab.value.laboratory)"
      [hasError]="selectedLab.invalid">
      <div class="panel panel-default">
        <div class="panel-body">
          <div class="row">
            <app-sampling-needs-form
              [samplingNeeds]="selectedLab"
              [tissueTypes]="tissueTypes"
              [assays]="assaysForLab(selectedLab.value.laboratory)"
              [projectedTaskConfigurations]="projectedTaskConfigurations"
              [tissueCollectionTypes]="tissueCollectionTypes"
              [growthStages]="growthStages"
              [requestDetails]="requestDetails">
            </app-sampling-needs-form>
          </div>

          <div class="row">
            <div class="text-right">
              <button class="btn btn-danger" type="button" (click)="remove(i)">
                Remove This Analysis
              </button>
            </div>
          </div>
      </div>
    </div>
  </app-vertical-tab>
</app-vertical-tab-group>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/sampling-needs/sampling-needs.component.html